<template>
  <div>
    <div class="content-header">
      <h2>集团简介</h2>
    </div>
    <div class="content-con">
      <div class="e_richText-1 s_title clearfix response-transition">
        <p>
          <br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;湖北省人才发展集团有限公司（简称湖北省人才发展集团），是长江产业投资集团的全资子公司，在湖北中新人力资源开发有限公司和湖北省人才市场有限责任公司基础上，聚合长江产业集团人力资源服务优势板块组建而成，湖北省人才市场有限责任公司为其全资子公司，目前正在组建若干个专业化、区域化人才公司，打造“四大平台”、协同“五大资源”、专注“六大业务”。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<span style="font-size: 18px"
            ><strong>一、打造“四大平台”</strong></span
          ><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;湖北省人才发展集团围绕实施人才强省战略和就业优先战略、打造全国科技创新高地和重要人才中心，建设全国构建新发展格局先行区和打造“三高地两基地”战略部署，坚持“人才服务、服务人才”理念，着力打造“高质量人才资源配置平台、高品质创新创业孵化平台、高水平数字人才支撑平台、高能级人才产业服务平台”，努力成为专业型、智慧型、价值型人才资源综合服务商，为湖北高质量发展提供强大的人才智力支撑。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<span style="font-size: 18px"
            ><strong>二、协同“五大资源”</strong></span
          ><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;湖北省人才发展集团已建成服务全省组织、人社系统的三级网络，与全省1000多家规上企业、全国1000多所高校长期合作，与全国人才服务行业的龙头企业、领军企业紧密合作，与人才科研院所、管理咨询机构及有关社团组织密切合作，形成立足湖北、辐射全国、面向全球的人才服务格局。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong
            ><span style="font-size: 18px">三、专注“六大业务”</span></strong
          ><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;依托三项具有比较优势的业务，拓展三项业态比较高端的业务，竭力提供高质量、全链条、全方位的人才服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>1</strong>、<strong
            >高校毕业生招聘</strong
          ><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;基于20多年的高校毕业生就业招聘服务，能够为各市州、各单位赴国内外高校开展招聘，提供全流程服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>2、高层次人才引进</strong><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;基于10多年的高层次人才出入境、创新创业、成果转化对接、综合性人才论坛等服务，能够为全省各单位引进全球高层次人才提供一站式服务，并为在鄂高层次人才创业创新、转化成果、学术交流提供个性化服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>3、社会化招考测评</strong><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;基于10多年的社会化招考测评服务，坚持创新合作、专业安全的发展之路。可调用专业化考评队伍超过2000人、标准化考场超过300间、多元化考题超过60万道、实战化资深考官超过1500名，能够提供全国一流的命题制卷服务，提供科学公正的内部人才选拔服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>4、赋能型派遣外包</strong><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;基于20多年的人才派遣外包服务，与机关事业单位、央企国企建立了高度信任、赋能增值的派遣外包合作关系。为近700家知名企业提供包括数字化档案管理在内的人才派遣外包服务，不断增加经济效益、降低生产成本，优化业务流程、和谐劳动关系，能够提供降本增效、合法合规、促进和谐的全方位服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>5、高质量咨询研究</strong><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;基于专业化的人才测评服务，以及正在建设的管理咨询、人才研究等机构，能够为机关事业单位、央企国企提供高质量的管理咨询、人才培训、课题研究等服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>6、数字化人才服务</strong><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;基于20多年的人才服务数据积累，目前正在加快数字化转型，力争今年陆续推出数字化人才服务项目，为企事业单位提供更好的人力资源开发管理服务。
        </p>

        <p>
          <br />
          &nbsp; &nbsp; &nbsp; &nbsp;<strong>7、党政企干部教育培训</strong
          ><br />
          &nbsp; &nbsp; &nbsp;
          &nbsp;与华中科技大学高端智库组建湖北人才发展集团干部教育中心，联合开发高品质干部教育培训项目，打造干部教育和企业培训精品课程，整合华科、武大、浙大、南大、川大、西交大、苏大等全国40余所“双一流”大学优质资源，根据政企客户需求在湖北省内和全国各地开展党性教育、理论教育、知识培训与履职能力培训项目；同时对传统干部教育培训业务进行数字化和AI化改造，高质量完成新时代组织部门、党政机关和企事业单位的干部教育和专业人才培养的重任。
        </p>

        <p><br /></p>

        <div class="ckeditor-html5-video" style="text-align: center">
          <video
            controls
            id="video_1704751721639731200"
            :src="url ? 'https://' + url : ''"
            style="width: 100%"
          >
            &nbsp;
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVideo } from "@/api/index";
export default {
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const loading = this.$loading();
      getVideo("/videos/sp.mp4")
        .then((res) => {
          loading.close();
          this.url = res;
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

